import React, { useEffect } from "react";
import { Loader, ReactChildrenProps } from "ecom-teams-apps-core";
import { observer } from "mobx-react-lite";
import pl from "shared/messages/pl";
import { useStore } from "stores/Stores";
import styles from "./configProvider.module.scss";
import ErrorModal from "modals/ErrorModal";

const ConfigProvider: React.FC<ReactChildrenProps> = observer((props: ReactChildrenProps) => {
    const { configStore } = useStore();

    useEffect(() => {
        configStore.loadConfig();
    }, [configStore]);

    const renderLoader = () => {
        return (
            <div className={styles.loaderWrapper}>
                <Loader text={pl.common.appLoading} />
            </div>
        );
    };

    const renderErrorModal = () => {
        return (
            <ErrorModal
                header={pl.configProvider.loadConfigError.header}
                message={pl.configProvider.loadConfigError.content}
            />
        );
    };

    return !configStore.loadConfigRequestStatus.isDone ? (
        renderLoader()
    ) : configStore.loadConfigRequestStatus.error ? (
        renderErrorModal()
    ) : (
        <>{props.children}</>
    );
});

export default ConfigProvider;
